import React from 'react';
import { Radio } from 'alurkerja-ui';
import { FormField, IFormField } from './FormField';

interface RadioFieldProps extends IFormField {
  options?: IRadioOption[];
  defaultValue?: string;
  value?: string;
  onChange?: (key: string | number | null) => void;
}

export type IRadioOption = { label: string; key: string | number };

export const RadioField: React.FC<RadioFieldProps> = props => {
  return (
    <FormField
      {...props}
      render={({ field }) => (
        <Radio
          name={props.name}
          defaultValue={props.defaultValue}
          onChange={e => field.onChange(e)}
          listOption={props.options}
        />
      )}
    />
  );
};
